/* tslint:disable:typedef-whitespace */
/*
tslint:disable:import-spacing no-inferrable-types
variable-name align no-trailing-whitespace component-class-suffix
no-string-literal component-selector
*/

import {ICommand}            from '@/util/i.command';
import {WorkBloxEditor}      from './work.blox.editor';

/**
 *
 * @class SetDaysCommand
 *
 * @brief reversible updates of the active days column
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      June 2020
 *
 */
export class SetDaysCommand implements ICommand {

  private oldValue: number[];
  private newValue: number[];
  private editor:   WorkBloxEditor;

  constructor(oldValue: number[], newValue: number[], editor: WorkBloxEditor) {

    this.oldValue = oldValue;
    this.newValue = newValue;
    this.editor   = editor;
  }

  /** effect the command */
  execute() {

    this.editor.setDays(this.newValue);
  }

  /** reverse the command's effects */
  unExecute() {

    this.editor.setDays(this.oldValue);
  }

  /** return a string summary of this command */
  asString(): string {

    return '[days] ' + JSON.stringify(this.oldValue) + ' => ' + JSON.stringify(this.newValue);
  }

}
